import { Box, BoxProps, ColorOptions, EmptyView, Image, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useState } from 'react'
import { FlatList } from 'react-native'
import { ImageUrlDetection } from '../../../../../libs/ui-new/src/utils/utils'
import { useStores } from '../../data/store'
import { Header } from '../../nav/PayStack'
import { convertHexToRGBA, formatAmount } from '../../utils'

const styles = (theme: any) => ({
  itemTitleText: {
    color: theme.bodyTextColor,
    fontFamily: 'jiotype-medium',
    fontSize: 14,
  } as TextProps,
  itemSubTitleText: {
    color: convertHexToRGBA(theme?.bodyTextColor, 70) as ColorOptions,
    fontFamily: 'jiotype-medium',
    fontSize: 12,
  } as TextProps,
  itemOfferDetail: {
    color: theme.bodyTextColor,
    fontFamily: 'jiotype-light-italic',
    fontSize: 12,
    lineHeight: 22,
  } as TextProps,
  viewOfferBtn: {
    position: 'absolute',
    right: 16,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  offerbtnText: {
    color: theme.brandColor,
    fontFamily: 'jiotype-bold',
    fontSize: 12,
  } as TextProps,
  itemStyle: {
    flexDirection: 'row',
    paddingVertical: 16,
    paddingHorizontal: 16,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  OfferBtn: {
    padding: 16,
    bg: theme.brandColor,
    height: 40,
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center',
    borderRadius: 5,
  } as BoxProps,
  offerBtnText: {
    color: theme.bodyBgColor,
    fontFamily: 'jiotype-medium',
    fontSize: 12,
  } as TextProps,
  separatorStyle: { height: 1, backgroundColor: 'DISABLED_GREY', zIndex: -1 } as BoxProps,
})

const OfferBtn = ({ onPress, title }: any) => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))
  return (
    <Box onPress={onPress} {...styles(theme).OfferBtn} underlayColor={theme.brandColor as ColorOptions}>
      <Text value={title} {...styles(theme).offerBtnText} />
    </Box>
  )
}

const Offers: FC = () => {
  const { getOfferData, updateSelectedOffer, theme, updateShowPopup } = useStores((root) => ({
    getOfferData: root.getOfferData,
    leng: root.offer.length,
    updateSelectedOffer: root.updateSelectedOffer,
    theme: root?.config?.merchantTheme,
    updateShowPopup: root.config.updateShowPopup,
  }))

  const [selected, setSelected] = useState('')

  // const returnPaymentMode: any = (paymentType: any) => {
  //   console.log('**** paymentMode: ', paymentType)
  //   if (paymentType === 'card') {
  //     return paymentMode.CARD
  //   } else if (paymentType === 'netbanking') {
  //     return paymentMode.NET_BANKING
  //   } else if (paymentType === 'wallet') {
  //     return paymentMode.WALLET
  //   } else if (paymentType === 'upi') {
  //     return paymentMode.UPI
  //   }

  //   return 'jiomoney'
  // }
  const renderItem = ({ item }: { item: any; index: number }) => {
    return (
      <Box
        {...styles(theme).itemStyle}
        onPress={() => {
          setSelected(item?.id)
        }}>
        <Box>
          <Spacer size={6} />
          <Image width={20} height={20} resizeMode="center" source={ImageUrlDetection(item.imageUrl)} />
        </Box>
        <Spacer direction="horizontal" size={8} />
        <Box paddingHorizontal={8} f={1}>
          <Text value={item.title} {...styles(theme).itemTitleText} />
          <Spacer size={4} />
          <Text value={item.subTitle} {...styles(theme).itemSubTitleText} />
          {selected === item.id && (
            <Box>
              <Spacer size={16} />
              <Text value={item.offerDetail} {...styles(theme).itemOfferDetail} />
              <Spacer size={16} />
              <OfferBtn
                title={
                  item?.isNoCostEmiOffer
                    ? 'Apply NoCost EMI offer'
                    : `Apply offer & save ₹ ${formatAmount(item.offerValue)}`
                }
                onPress={() => {
                  updateSelectedOffer(item.code, item.paymentModeType, item.paymentModeSubType)
                  console.log('item: ', item)
                  if (canGoBack()) {
                    updateShowPopup(false)
                    goBack()
                  }
                }}
              />
              <Spacer size={16} />
            </Box>
          )}
        </Box>
      </Box>
    )
  }
  const getSeperator = () => {
    return <Box {...styles(theme).separatorStyle} />
  }

  const offerData = getOfferData()

  const { goBack, canGoBack } = useNavigation()
  return (
    <Box flex={1} bg={theme.bodyBgColor as ColorOptions}>
      <Header
        title={`AVAILABLE OFFERS (${offerData.length})`}
        onGoBack={() => {
          if (canGoBack()) {
            updateShowPopup(false)
            goBack()
          }
        }}
        theme={theme}
      />
      <FlatList
        renderItem={renderItem}
        data={offerData}
        contentContainerStyle={{ flex: 1 }}
        ItemSeparatorComponent={getSeperator}
        keyExtractor={(item) => `offerItems-${item.id}`}
        ListEmptyComponent={<EmptyView isLoading={false} onRetry={() => {}} emptyMessage="" />}
      />
    </Box>
  )
}

export default Offers
